import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { File} from '../../../_models/file';
import { Location } from '@angular/common';

import { FormValidator } from '../../../_helpers/form.validator';
import { FileValidator } from '../../file.validator';

import { AuxFunction } from '../../../_helpers/aux.function';

import { Translation } from '../../../_languages/translations';

@Component({
  selector: 'app-file-edit',
  templateUrl: './file-edit.component.html'
})
export class FileEditComponent implements OnInit, OnChanges {

  // Para el control del diccionario de traducción.
  tr: {};

  title: string;
  subtitle: string;

  // Información del usuario actual logueado.
  current_user_id: number;
  current_user_email: string;
  current_user_name: string;
  current_user_group_id: number;
  current_user_lang: string;
  current_user_enviroment: string;
  current_user_company: string;

  // Control de permisos
  permissions: string;

  fileForm: FormGroup;

  actionModal: boolean;
  alertModal: boolean;
  infoModal: boolean;

  fileModal: boolean;

  actionInfo: string;
  alertInfo: string;
  infoInfo: string;

  today: Date;

  auxFunction: AuxFunction;

  // Variable para el control de las validaciones del formulario y sus mensajes.
  formValidator: FormValidator;

  selectedFile: File;

  @Input() file: File;
  @Input() infoList: any;
  @Input() fileList: File[];
  @Output() updateFile = new EventEmitter<File>();
  @Output() saveFile = new EventEmitter<any>();
  @Output() optimizerFile = new EventEmitter<any>();
  @Output() showInfoModal = new EventEmitter<{ value: boolean, info: string, link: string, skin: string }>();

  constructor(
    public router: Router,
    private formBuilder: FormBuilder,
    private _location: Location,
    public trans: Translation
  ) {
    this.formValidator = new FormValidator();
  }

  // convenience getter for easy access to form fields
  get f() { return this.fileForm.controls; }

  ngOnInit() {

    this.tr = this.trans.vocabulary;

    this.auxFunction = new AuxFunction();

    this.permissions = localStorage.getItem('permissions');
    console.log('-> -> Iniciando tab-composition permissions:' + this.permissions);

    this.current_user_id = Number(localStorage.getItem('user_id'));
    this.current_user_email = localStorage.getItem('email');
    this.current_user_name = localStorage.getItem('name');
    this.current_user_group_id = Number(localStorage.getItem('group_id'));
    this.current_user_lang = localStorage.getItem('lang');
    this.current_user_enviroment = localStorage.getItem('enviroment');
    this.current_user_company = localStorage.getItem('company');

    console.log(' -> current_user_id: ' + this.current_user_id);
    console.log(' -> current_user_email: ' + this.current_user_email);
    console.log(' -> current_user_name: ' + this.current_user_name);
    console.log(' -> current_user_group_id: ' + this.current_user_group_id);
    console.log(' -> current_user_lang: ' + this.current_user_lang);
    console.log(' -> current_user_enviroment: ' + this.current_user_enviroment);
    console.log(' -> current_user_company: ' + this.current_user_company);


    this.fileForm = this.formBuilder.group({
      // id: this.file.id,
      // file_type_id: [1, Validators.required],
      path: [this.file.path, Validators.required],
      // name: [this.file.name, Validators.required],
      // desc: [this.file.description, Validators.required],
      // order: this.file.order,
      // state: this.file.state,
      // code: this.file.code,
      // date: this.file.date,
      // user: [this.file.user, Validators.required],
      // active: this.file.active

    });

    // Asignamos los mensajes de error asociados a las validaciones que vamos a usar en el formulario.
    this.formValidator.setTemplateMessages(FileValidator.templateMessages);

    this.title = this.tr['st1_title'];
    this.subtitle = this.tr['st1_subtitle'];

    this.actionInfo = this.tr['st1_actionInfo'];

    this.infoInfo = this.tr['st1_actionOk'];

    this.actionModal = false;
    this.fileModal = false;

    // Se crean las subscripciones para el control de los campos del formulario.
    this.formValidator.subscribeFormGroup(this.fileForm);

  } // End function OnInit

  ngOnChanges(changes: SimpleChanges) {

    console.log('->-> Entrando en ngOnChanges de file-edit: ');
    console.log(changes);

    if (changes.file) {
      console.log('--> ngOnChanges file-edit file:');

      // Si no es la primera vez que se ejecuta entonces se validan los selectores.
      // Esto evita un error inicial que se produciría al cargar la página debido
      // a que intentaría obtener los valores del formulario antes de estar creado.
      if (!changes.file.isFirstChange()) {

        console.log('--> ngOnChanges file-edit file: NO es la primera vez.');
        console.log(changes.file.currentValue);

      }
    }

    if (changes.infoList) {
      console.log('--> ngOnChanges file-edit infoList:');

      if (!changes.infoList.isFirstChange()) {

        console.log('--> ngOnChanges file-edit infoList: NO es la primera vez.');
        console.log(changes.infoList.currentValue);
      }
    }

  } // End function ngOnChanges

  saveFileAction(): void {

    // NOTA: Se copian los cambios sobre la obra inicial.
    const p = { ...this.file, ...this.fileForm.value };

    this.updateFile.emit(p);

  } // End function saveFileAction

  loadDataFile(): void {

    console.log('->> >> loadDataFile getContentCSV:');
    // console.log(this.auxFunction.getContentCSV());

    this.saveFile.emit(this.auxFunction.getContentCSV('piece'));

  } // End function saveElementList

  optimizerFileAction(): void {

    const p = { ...this.file, ...this.fileForm.value };

    this.optimizerFile.emit(p);

    // this.auxFunction.downloadFile(file);

  } // End function optimizerFileAction

  // ------------------------------------
  //    VALIDACIÓN FINAL DEL FORMULARIO
  // ------------------------------------

  validateFile(): void {

    // Se realizan las comprobaciones pertinentes para confirmar que los campos del formulario son correctos.

    if (this.fileForm.valid) {
      console.log('-------> Formulario fileForm correcto.');

      // Comprobaciones que no estén definidas ya en la declaración del formulario.
      if (this.fileForm.controls.path.value.trim() === '') {

        this.alertInfo = 'Debe indicar una ruta para el directorio.';
        this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});

      } else {

        this.showActionModal(true);
      }
    } else {
      console.log('-------> Formulario fileForm NO válido:');
      console.log(this.fileForm);

      this.alertInfo = 'El formulario no está correctamente rellenado:<br>';

      if (this.fileForm.controls.path.value === '') {

        this.alertInfo += ' - Debe indicar una ruta para el directorio.';
      }

      this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
    }
  } // End function validateFile

  // ------- Función de regreso
  back(): void {
    // this._location.back();
    this.router.navigate(['/main']);
  } // End function back

  // -----------------------------------------------
  //  FUNCIONES PARA EL CONTROL DE VENTANAS MODALES
  // -----------------------------------------------

  showFileModal(value: boolean) {
    this.fileModal = value;
  } // End function showFileModal

  confirmFileModal() {

    console.log('--> - -> Confirmada acción del modal de carga de archivo de optimización.');

    // this.loadDataFile();

    this.optimizerFileAction();

    this.showFileModal(false);
  } // End function confirmFileModal

  showActionModal(value: boolean) {
    this.actionModal = value;

  } // End function showActionModal

  confirmActionModal() {

    console.log('--> - -> Confirmada acción del modal.');

    // this.saveFileAction();

    this.optimizerFileAction();

    this.showActionModal(false);
  } // End function confirmActionModal

} // End Class FileEditComponent
